import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-322504df"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "my-info-container",
  ref: "scrollContainer"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal-content" }, " 현재 화면을 벗어나면 입력 중인 내용은 사라집니다. 저장하지 않고 나가시겠습니까? ", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createVNode($setup["NavigationBar"], {
        title: "회원정보 수정",
        overrideOnClickBack: true,
        onOnClickBack: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleShowConfirmGoBackModal(true)))
      }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode($setup["DynamicEditMyInfoForm"], {
          rankCode: $setup.rankCode,
          userInfo: $setup.userInfo,
          onOnClickEditMyInfoBtn: $setup.editMyInfo
        }, null, 8 /* PROPS */, ["rankCode", "userInfo"])
      ], 512 /* NEED_PATCH */),
      ($setup.scrollContainer)
        ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
            key: 0,
            container: $setup.scrollContainer,
            style: { bottom: '80px' }
          }, null, 8 /* PROPS */, ["container"]))
        : _createCommentVNode("v-if", true),
      ($setup.shouldShowConfirmGoBackModal)
        ? (_openBlock(), _createBlock($setup["Modal"], {
            key: 1,
            title: "나가기",
            okButtonTitle: "나가기",
            cancelButtonTitle: "취소",
            onOnClickOkButton: _cache[1] || (_cache[1] = ($event: any) => ([$setup.toggleShowConfirmGoBackModal(false), $setup.goToBack()])),
            onOnClickCancelButton: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleShowConfirmGoBackModal(false)))
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}